import * as React from 'react'
import colors from 'theme/colors'

const SvgComponent = ({
  color = colors.white,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 17
  const h = 17
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_1270_33623"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="15"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.80273 1.80469H15.4691V15.471H1.80273V1.80469Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask0_1270_33623)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.3756 3.84545C3.37693 3.84545 3.3436 3.88012 3.3016 3.92145C3.14027 4.07812 2.80627 4.40412 2.80293 5.08612C2.7976 6.04012 3.42493 7.81145 6.4456 10.8315C9.45227 13.8368 11.2209 14.4715 12.1769 14.4715H12.1909C12.8729 14.4681 13.1983 14.1335 13.3556 13.9728C13.4036 13.9235 13.4423 13.8875 13.4696 13.8648C14.1336 13.1968 14.4736 12.6995 14.4703 12.3808C14.4656 12.0555 14.0609 11.6708 13.5016 11.1388C13.3236 10.9695 13.1303 10.7855 12.9263 10.5815C12.3976 10.0541 12.1356 10.1441 11.5596 10.3468C10.7629 10.6261 9.6696 11.0061 7.97093 9.30679C6.2696 7.60679 6.65027 6.51479 6.92893 5.71812C7.13027 5.14212 7.22227 4.87945 6.69293 4.35012C6.4856 4.14345 6.2996 3.94745 6.12827 3.76745C5.5996 3.21145 5.21827 2.80945 4.89493 2.80479H4.8896C4.57027 2.80479 4.07427 3.14612 3.37227 3.84812C3.37427 3.84612 3.37493 3.84545 3.3756 3.84545V3.84545ZM12.1775 15.4715C10.5161 15.4715 8.35012 14.1488 5.73879 11.5388C3.11746 8.91812 1.79279 6.74546 1.80279 5.08079C1.80879 3.98079 2.38546 3.41746 2.60212 3.20612C2.61346 3.19212 2.65212 3.15412 2.66546 3.14079C3.62146 2.18412 4.26612 1.79746 4.90746 1.80479C5.65212 1.81479 6.18212 2.37212 6.85279 3.07812C7.01879 3.25279 7.19879 3.44279 7.39946 3.64279C8.37279 4.61612 8.09546 5.41012 7.87279 6.04746C7.63012 6.74279 7.42012 7.34279 8.67746 8.60012C9.93612 9.85746 10.5361 9.64746 11.2288 9.40279C11.8668 9.18012 12.6588 8.90146 13.6335 9.87479C13.8308 10.0721 14.0181 10.2501 14.1908 10.4148C14.9001 11.0888 15.4601 11.6215 15.4695 12.3681C15.4775 13.0048 15.0908 13.6535 14.1361 14.6088L13.7135 14.3221L14.0708 14.6715C13.8595 14.8881 13.2968 15.4655 12.1961 15.4715H12.1775Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default SvgComponent
